(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a4d921d"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nightly-scroll-journey')) {
  customElements.define('nightly-scroll-journey', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.frame = 0;
      this.update = () => {
        this.frame = 0;
        const steps = this.querySelector('[class$="__steps"]');
        const rail = this.querySelector('[class$="__rail"]');
        const rings = Array.from(this.querySelectorAll('[class$="__ring"]'));
        if (!steps || !rail || !rings.length) return;
        const bounds = rings.map(ring => ring.getBoundingClientRect());
        const centres = bounds.map(rect => rect.top + rect.height / 2);
        const origin = steps.getBoundingClientRect().top;
        const length = Math.max(0, centres[centres.length - 1] - centres[0]);
        const position = window.innerHeight * 0.65;
        const progress = length ? Math.max(0, Math.min(1, (position - centres[0]) / length)) : 0;
        rail.style.top = (centres[0] - origin) + 'px';
        rail.style.bottom = 'auto';
        rail.style.height = length + 'px';
        rail.style.setProperty('--journey-progress', progress);
        rings.forEach((ring, i) => ring.parentElement.classList.toggle('is-reached', position >= centres[i]));
      };
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(this.update); };
      window.addEventListener('scroll', this.schedule, {passive:true, signal:this.controller.signal});
      window.addEventListener('resize', this.schedule, {passive:true, signal:this.controller.signal});
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.schedule();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
